import React from 'react';

const TravelTypes: React.FC = () => {
  return (
    <section className="travel-types">
      <div className="container">
        <div className="travel-types-grid">
          <div className="travel-type-card">
            <div className="travel-type-image beach-paradise"></div>
            <h3 className="travel-type-title">Beach Paradise</h3>
          </div>
          <div className="travel-type-card">
            <div className="travel-type-image mountain-adventure"></div>
            <h3 className="travel-type-title">Mountain Adventure</h3>
          </div>
          <div className="travel-type-card">
            <div className="travel-type-image cultural-experience"></div>
            <h3 className="travel-type-title">Cultural Experience</h3>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TravelTypes; 